<template>
    <div v-if="rows.length > 0" :class="[`flex`, `flex-col`]">
        <div v-for="(row, index) in rows" :key="index">
            <hr />
            <RowWithImage
                :textAlign="textAlign"
                :pictureOrientation="pictureOrientation"
                :heading="row.heading"
                :subtext="row.subtext"
                :image="row.image"
                :imageAlt="row.imageAlt"
            />
        </div>
        <hr />
    </div>
</template>
<script lang="ts" setup>
    import { computed, ref } from "vue";
    import RowWithImage from "@/components/RowWithImage.vue";
    let { rows, textAlign, pictureOrientation } = defineProps({
        rows: {
            type: Array,
            default: []
        },
        textAlign: {
            type: String,
            default: "left"
        },
        pictureOrientation: {
            type: String,
            default: "left"
        }
    });
</script>
